import React, { useState, useEffect } from 'react'
import './index.sass'
import Header from "../common/FeedHeader"
import Usercard from './Usercard'


import { getSuggestedFollowers } from '../../api/feed'

import { useSelector } from 'react-redux';
import { SuggestedShimmer } from '../common/Shimmer'

export default function Suggested({onFollow}) {
    const id = useSelector(store => store.userState.id);
    const [loadingUserList, setLoadingUserList] = useState(true);
    const [suggestedList, setSuggestedList] = useState([]);

    const updateSuggestedFollowersList = async (id) => {
        console.log('showing shimmer')
        const res = await getSuggestedFollowers(id);
        if(res){
            setSuggestedList(res);
            setLoadingUserList(false)
            console.log('hiding shimmer', res)
        }
    }

    useEffect(() => {
        
        if (id != undefined && id != null) {
            setLoadingUserList(true)
            updateSuggestedFollowersList(id)
        }
    }, [id])

    return (
        <div id="feedSuggested">
            <Header img="compass.svg" text="Suggested Lovrs" />
            <div id="feedSuggestedList">
                {
                    loadingUserList ?
                    <div >
                        <SuggestedShimmer />
                        <SuggestedShimmer />
                        <SuggestedShimmer />
                    </div> :
                    suggestedList && suggestedList.length > 0 ? 
                    suggestedList.map(user => <Usercard onFollow={onFollow} key={user.id} thumb={user.thumbnail} id={user.id} name={user.name} username={user.username} image={user.image} followers={user.followersCount} price={user.price} />) : 
                    <div></div>
                }
            </div>

            <div className="bottom-menu">
                    <p><a href="/about">ABOUT</a> • <a href="/help">HELP</a> • <a href="/terms">TERMS</a> • <a href="/privacy">PRIVACY</a> • <a href="/cookies">COOKIES</a> • <a href="/copyright">COPYRIGHT</a></p>
                    <h5>© 2021 Copyright by LOVR.online . All Rights reserved!</h5>
                </div>
        </div>
    )
}
